import { SyntheticEvent, useState } from 'react';
import { useModal } from '../../contexts/ModalContext';
import { BaseModal, BaseModalProps } from './BaseModal';
import { TabControls } from '../common/tabs/TabControls';
import { TableWidget, TableWidgetColumns } from '../widgets/TableWidget';
import { setLocalString } from '../../pages/intervals/intervalModal/utils/intervalSumHelper';
import { SummaryBoard } from '../common/SummaryBoard';

export default function InvoiceModal({ name }: BaseModalProps) {
  const columnsTasks: TableWidgetColumns[] = [
    {
      name: 'Datum',
      id: 'period',
      columnSpan: 2,
    },
    {
      name: 'Beskrivning',
      id: 'description',
      columnSpan: 2,
    },
    {
      name: 'Summa',
      id: 'scheduledTaskSum',
      columnSpan: 5,
      columnAlignment: 'right',
    },
    {
      name: 'Status',
      id: 'colorStatus',
      columnSpan: 1,
      columnAlignment: 'right',
    },
  ];

  const columnsProducts: TableWidgetColumns[] = [
    {
      name: 'Datum',
      id: 'period',
      columnSpan: 2,
    },
    {
      name: 'Art. Nr.',
      id: 'articleNumber',
      columnSpan: 2,
    },
    {
      name: 'Benämning',
      id: 'name',
      columnSpan: 4,
    },
    {
      name: 'Listpris',
      id: 'listPrice',
      columnSpan: 2,
    },
    {
      name: 'Rabatt',
      id: 'discount',
      columnSpan: 2,
    },
    {
      name: 'Pris',
      id: 'price',
      columnSpan: 2,
    },
    {
      name: 'Antal',
      id: 'amount',
      columnSpan: 2,
    },
    {
      name: 'Summa',
      id: 'total',
      columnSpan: 2,
      columnAlignment: 'right',
    },
  ];

  const columnsExtraBilling: TableWidgetColumns[] = [
    {
      name: 'Datum',
      id: 'period',
      columnSpan: 2,
    },
    {
      name: 'Beskrivning',
      id: 'description',
      columnSpan: 2,
    },
    {
      name: 'Pris',
      id: 'price',
      columnSpan: 1,
    },
    {
      name: 'Antal',
      id: 'amount',
      columnSpan: 1,
    },
    {
      name: 'Summa',
      id: 'total',
      columnSpan: 2,
      columnAlignment: 'right',
    },
  ];

  const { modalState } = useModal();
  const [activeTabValue, setActiveTabValue] = useState(0);

  const payload = modalState.InvoiceModal.payload ?? {};

  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setActiveTabValue(newValue);
  };

  const customerDetails = [
    { label: 'Kund', value: payload.customerInformation.customerName },
    { label: 'Adress', value: payload.projectAddress },
    { label: 'Tjänst', value: payload.service },
  ];

  const priceDetails = [
    { label: 'Prissättningsform', value: payload.debitType },
    { label: 'Faktureringsform', value: payload.invoiceType },
    { label: 'Underlagssumma', value: `${setLocalString(payload.orderValue)} kr` },
  ];

  const sections = [
    { title: ' ', items: customerDetails },
    { title: ' ', items: priceDetails },
  ];

  return (
    <BaseModal title={`Fakturaunderlag`} name="InvoiceModal" subtitle={`Period ${payload.period}`}>
      <SummaryBoard sections={sections} />
      <TabControls
        tabValue={activeTabValue}
        tabs={['Uppdrag', 'Produkter', 'Extra debiteringar']}
        handleChangeTabs={handleChangeTabs}
      />
      {activeTabValue === 0 && (
        <TableWidget data={payload.invoiceTaskRows} columns={columnsTasks} isScrollable />
      )}
      {activeTabValue === 1 && (
        <TableWidget data={payload.invoiceProducts} columns={columnsProducts} isScrollable />
      )}
      {activeTabValue === 2 && (
        <TableWidget
          data={payload.invoiceExtraBillings}
          columns={columnsExtraBilling}
          isScrollable
        />
      )}
    </BaseModal>
  );
}
